import { useState, useEffect } from "react";
import { Provider } from "react-redux";
import MainRoutes from "./routes";
import { store } from "./redux/storeOf";
import "./App.css";
import { Result, Button, Card, Row, Col, Space, Tag, Divider } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useAxiosSessionInterceptor } from "./utils/useAxiosSessionInterceptor";
import { useIdleTimer } from "react-idle-timer";

function App() {
  useAxiosSessionInterceptor();

  // BEGIN IDLE LOGIC

  const handleOnIdle = (event) => {
    console.log("last active", getLastActiveTime());

    window.location.href = "/sign-in";
  };

  const handleOnActive = (event) => {
    console.log("user is active", event);
    console.log("time remaining", getRemainingTime());
  };

  const handleOnAction = (event) => {
    // console.log("user did something", event);
  };
  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 300_000,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 250,
  });
  // END IDLE LOGIC

  return (
    <Provider store={store}>
      <MainRoutes />
    </Provider>
  );
}

export default App;
